import React from 'react';
import { useSelector } from 'react-redux';
import SatButton from '@components/common/satUI/SatButton';

const ConcludeAccount = props => {
  const { customerName, empName, onClickConfirmBtn } = props;
  const { channelInfo } = useSelector(state => state.userReducer);

  return (
    <>
      <header className="modal-header">
        <h3 className="layer-tit2">
          금융소비자보호를 위한 계약체결 종합확인서
        </h3>
      </header>

      <div className="cont modal-scroll-wrap">
        <p className="text-info4">
          {`계약자 ${customerName}는(은)${
            $utils.checkLP(channelInfo.cdVal) && !channelInfo.lpDeptYn ? ' 라이프파트너' : ' 보험설계사'
          } ${empName}을(를) 직접 만나서 모집종사자의
          중요사항 고지 및 보험상품판매 관련 주요사항 고지에 대해 모두 고지
          받았음을 확인합니다.`}
        </p>
        <div className="info-box bg-yellow mgt-16 mgb-0">
          <p className="text-info3">
            계약체결 과정에서 관계법령에 따른 모집종사자의 고지의무를 확인하고
            판매원칙을 준수하였음을 확인받고 있습니다.
          </p>
        </div>
      </div>
      <div className="layer-footer">
        <SatButton
          styleClass={`btn-s blue btn-wide`}
          label={'확인'}
          onClick={() => onClickConfirmBtn()}
        />
      </div>
    </>
  );
};

export default ConcludeAccount;
